import * as APIRoutes from '@mm/api-routes';
import { Omit } from '@mm/utils';
import { LinkTypes, PromoterModel } from '../model/PromoterModel';
import AuthenticatedController from './AuthenticatedController';

type BeAndFeCombined = PromoterModel & { kind: LinkTypes };

export type BePromoterModel = Omit<BeAndFeCombined, 'type'>;

export const mapBEtoFE = (item: BePromoterModel): PromoterModel => ({
  ...item,
  type: item.kind,
});

const mapFEtoBE = (item: PromoterModel): BePromoterModel => ({
  ...item,
  kind: item.type,
});

class PromoterController extends AuthenticatedController {
  static async getAll(botId: number, kind = ''): Promise<PromoterModel[]> {
    const response = await super.get(
      `${APIRoutes.PROMOTERS(botId)}?kind=${kind}`,
    );
    return response.map(mapBEtoFE);
  }

  static async getPromoterById(
    botId: number,
    promoterId: number,
  ): Promise<PromoterModel> {
    const response = await super.get(
      `${APIRoutes.BOTS}/${botId}/promoters/${promoterId}`,
    );
    return mapBEtoFE(response);
  }

  static async getCatchAllGuard(botId: number) {
    const response = await super.get(
      `${APIRoutes.PROMOTERS(botId)}/catch_all_comment_guard`,
    );
    return mapBEtoFE(response);
  }

  static async postPromoter(promoter: PromoterModel): Promise<PromoterModel> {
    const mappedPromoter = mapFEtoBE(promoter);
    const response = await super.post(
      APIRoutes.PROMOTERS(mappedPromoter.botId),
      mappedPromoter,
    );
    return mapBEtoFE(response.promoter);
  }

  static async putPromoter(
    botId: number,
    promoter: Partial<PromoterModel>,
  ): Promise<PromoterModel> {
    const mappedPromoter = mapFEtoBE(promoter as PromoterModel);
    const requestUrl = `${APIRoutes.PROMOTERS(botId)}/${mappedPromoter.id}`;
    const response = await super.put(requestUrl, mappedPromoter);
    return mapBEtoFE(response.promoter);
  }

  static deleteBotPromoterById(
    botId: number,
    promoterId?: number, // TODO fixsomeone PromoterModel as this is required
  ): Promise<void> {
    return super.delete(`${APIRoutes.PROMOTERS(botId)}/${promoterId}`);
  }

  static deletePromoter(
    promoter: Pick<PromoterModel, 'botId' | 'id'>,
  ): Promise<void> {
    return PromoterController.deleteBotPromoterById(
      promoter.botId,
      promoter.id,
    );
  }

  static async moveToCampaign({
    botId,
    campaignId,
    promoterId,
  }: {
    botId: number;
    promoterId: number;
    campaignId: number;
  }): Promise<PromoterModel> {
    const response = await super.post(
      `${APIRoutes.PROMOTERS(
        botId,
      )}/${promoterId}/move_to_campaign/${campaignId}`,
      {},
    );
    return mapBEtoFE(response);
  }
}

export default PromoterController;
